import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function Hero() {
  return <section className="relative pt-10 pb-12 px-4 lg:pt-14 lg:pb-16 overflow-hidden" data-id="element-139">
      {/* Subtle background decoration */}
      <div className="absolute top-0 left-0 w-full h-full bg-cream-dark opacity-30 -z-10 rounded-b-[100px] lg:rounded-b-[200px]" data-id="element-140"></div>

      <div className="max-w-3xl mx-auto text-center" data-id="element-141">
        <FadeIn data-id="element-142">
          <div className="inline-flex items-center justify-center px-3 py-1.5 mb-4 rounded-full bg-sage/10 text-sage-dark font-medium text-xs tracking-wide uppercase" data-id="element-143">
            <span className="mr-1.5 text-base" data-id="element-144">🌿</span>
            Sabiduría Natural
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brown-dark mb-3 leading-tight" data-id="element-145">
            LA BOTICA DE LA <br className="hidden md:block" data-id="element-146" />
            <span className="text-amber-dark italic" data-id="element-147">ABUELA MODERNA</span>
          </h1>
          <p className="text-lg md:text-xl text-brown mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-148">
            Remedios de siempre con lo que encuentras hoy en el supermercado de
            USA.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-149">
          <div className="relative max-w-sm mx-auto mb-6" data-id="element-150">
            <div className="absolute -inset-3 bg-amber/20 rounded-[2rem] blur-xl opacity-50" data-id="element-151"></div>
            <img src="https://cdn.magicpatterns.com/uploads/9a4vhTTwWmMtZeLT9KHqqv/heylloyd-image-1776220135630.png" alt="La Botica de la Abuela Moderna - Libro Digital" className="relative rounded-2xl shadow-2xl w-full object-cover border-4 border-white/50" data-id="element-152" />
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-153">
          <Button href="#comprar" className="w-full sm:w-auto text-base md:text-lg px-8 py-4" data-id="element-154">
            Quiero mi copia ahora
          </Button>
          <p className="mt-3 text-sm text-brown-light" data-id="element-155">
            Descarga instantánea • 100% en Español
          </p>
        </FadeIn>
      </div>
    </section>;
}